/**
 * Ссылки в интерфейс самой биржи.
 *
 * Отдельным модулем, а не строкой в разметке: адрес приходит с провода, и
 * подставлять непроверенное в href значило бы уводить оператора по ссылке,
 * собранной из чужих данных.
 */

/** Кошелёк Polygon: ровно 20 байт, регистр любой. */
const ADDRESS = /^0x[0-9a-fA-F]{40}$/;

/**
 * Профиль кошелька на Polymarket.
 *
 * `null` означает «ссылку строить не из чего», и это НЕ то же, что пустая
 * страница: адреса в журнале бывают обрезанными (записи стендов) и нулевыми, а
 * ссылка на такой адрес открывала бы чужой профиль или пустоту. Молчащая ссылка
 * дешевле: внутренняя страница кошелька рядом никуда не девается.
 *
 * Адрес здесь — proxy-кошелёк (funder), тот самый, что стоит во встречных
 * строках сделки. Биржа знает участника именно по нему: EOA в её профиле не
 * ищется вовсе (docs/polymarket-integration.md, «Откуда взять эти четыре
 * значения»).
 */
export function profileURL(address: string | undefined | null): string | null {
  if (!address || !ADDRESS.test(address)) return null;
  return `https://polymarket.com/profile/${address}`;
}

/**
 * Как подписать кошелёк на экране: именем или адресом.
 *
 * # Зачем правило вообще нужно
 *
 * Потому что «имя есть» и «кошелёк подписан» — не одно и то же. Неподписанным
 * участникам биржа выдаёт псевдоним вида `0x3d79…3690-1753569356856`: это САМ
 * АДРЕС с меткой времени, то есть ноль сведений сверх адреса и вдвое больше
 * места под них. Пока имя и адрес стояли в разных колонках, разница была
 * безобидной; в одной колонке такой псевдоним вытесняет короткий адрес, который
 * читается лучше и который оператор узнаёт в лицо.
 *
 * Возвращается ФЛАГ, а не готовая строка: подписи нужны разные (ссылка, её
 * подсказка, сокращение), и решать, как сокращать адрес, обязан тот, кто
 * рисует.
 */
export function hasRealName(address: string, name: string): boolean {
  const trimmed = name.trim();
  if (trimmed === "") return false;
  // Сравнение по началу, а не на равенство: метка времени приписана через дефис,
  // и биржа меняла её формат. Регистр адреса у имени и у поля разный — источник
  // отдаёт имя как записал пользователь профиля.
  return !trimmed.toLowerCase().startsWith(address.trim().toLowerCase());
}
